import { useAuth0 } from '@auth0/auth0-react';
import { Navigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Dumbbell, LogIn, Loader2 } from 'lucide-react';

export function Login() {
  const { loginWithRedirect, isAuthenticated, isLoading } = useAuth0();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="w-8 h-8 animate-spin text-primary-500" />
      </div>
    );
  }

  if (isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="min-h-screen flex items-center justify-center p-4">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
        className="w-full max-w-md"
      >
        <div className="card text-center">
          {/* Logo */}
          <div className="w-20 h-20 mx-auto rounded-2xl bg-gradient-to-br from-primary-500 to-primary-600 flex items-center justify-center shadow-glow-lg mb-6 ring-1 ring-primary-400/30">
            <Dumbbell className="w-10 h-10 text-white" />
          </div>

          <h1 className="font-display text-3xl font-bold text-gradient mb-2">
            RUTINEO
          </h1>
          <p className="text-dark-400 mb-8">
            Gestión profesional de entrenamientos
          </p>

          <button
            onClick={() => loginWithRedirect()}
            className="btn-primary w-full py-4 text-lg"
          >
            <LogIn className="w-5 h-5" />
            Iniciar Sesión
          </button>

          <p className="text-sm text-dark-500 mt-6">
            ¿No tenés cuenta?{' '}
            <button
              onClick={() => loginWithRedirect({ authorizationParams: { screen_hint: 'signup' } })}
              className="text-primary-400 hover:text-primary-300 transition-colors"
            >
              Registrate
            </button>
          </p>
        </div>

        <p className="text-center text-dark-500 text-sm mt-6">
          Para entrenadores profesionales y sus alumnos
        </p>
      </motion.div>
    </div>
  );
}
